import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppState } from '../../../store/app-reducers';
import { NotificationsState } from '../../../store/reducers';

@Component({
  selector: 'badge-notifications',
  templateUrl: './badge-notifications.component.html',
  styleUrls: ['./badge-notifications.component.scss'],
})
export class BadgeNotificationsComponent implements OnInit, OnDestroy {

  public countBadge = 0;

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(private store: Store<AppState>) { }

  ngOnInit() {
    this.store.select('notifications')
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(this.callbackNotificacion);
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  public callbackNotificacion = (resp: NotificationsState) => {
    if (resp.success && resp.notifications.length > 0) {
      this.countBadge = resp.notifications.filter(n => !n.view).length;
    }
  }

}
